import React, { useCallback, useEffect, useState } from 'react';

import Section from '~/shared/Section';
import MessageCarousel from './components/MessagesCarousel';
import { useAppNavigate } from '..';
import { Stashboard, getStashboardData, useSpringBigStore } from '@springbig/shared';
import { useAuthorization } from '~/hooks/auth';
import Loading from '~/shared/Loading';

const MessageDetailScreen = () => {

    const { params } = useAppNavigate();
    const { isLoadingAuth } = useAuthorization();
    const [data, setData] = useState<Stashboard | null>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { member, setStashboardTarget } = useSpringBigStore();

    const getMessage = useCallback(async (stashboard_key: string) => {

        setIsLoading(true);

        const result = member && await getStashboardData({
            stashboard_key,
            type: 'sms',
        });

        result && setData(result);
        setIsLoading(false);
    }, [member]);

    useEffect(() => {

        if (params && params.stashboard_key) {
            setStashboardTarget(params.stashboard_key);
            getMessage(params.stashboard_key);
        }
    }, [member, params.wallet_id, params.stashboard_key, getMessage]);

    if (isLoading || isLoadingAuth) {
        return <Loading isLoading />;
    }


    return (
        <Section pb={10} flex={1} w={'100%'} display={'block'}>
            {data && <MessageCarousel data={data} />}
        </Section>
    );
};

export default MessageDetailScreen;
